/* global $:false */

/*
 * decaffeinate suggestions:
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

export default class BeneficialOwner {
  static init () {
    $(document).on('change', '.js-beneficial-owner-nationality select', function () {
      let needle
      if ((needle = $(this).val(), ['SE', 'FI'].includes(needle))) {
        $(this).parents('.js-beneficial-owner').find('.js-beneficial-owner-national-identifier').show()
        $(this).parents('.js-beneficial-owner').find('.js-beneficial-owner-birthday').hide()
      } else {
        $(this).parents('.js-beneficial-owner').find('.js-beneficial-owner-national-identifier').hide()
        $(this).parents('.js-beneficial-owner').find('.js-beneficial-owner-birthday').show()
      }
    })

    $('.js-beneficial-owner-nationality select').change()
  }
}
